import Cookies from 'js-cookie'
import jwtDecode from 'jwt-decode';
import { connection, portal_config } from '../portal.config';
import i18n from '../translations/i18n';
import { config_path } from '../router/config.path';
import { cache } from './cache';
import { dataUtil, usage_type } from '../wsclient/crmservices/dataUtil';

export const ACCESS_TOKEN = 'access_token';
export const REFRESH_TOKEN = 'refresh_token';
export const LANGUAGE = 'language_id';

var language_id = portal_config.default_language ? portal_config.default_language : "EN";
var is_logout_call = false;

export function saveDataIntoAsyncStore(key, data) {
    if (key === ACCESS_TOKEN || key === REFRESH_TOKEN) {
        try {
            let token = jwtDecode(data)
            let exp = new Date(token.exp * 1000);
            Cookies.set(key, data, { ...connection.cookiesConfig, expires: exp });
        }
        catch (e) {
            console.log('saveDataIntoAsyncStore e:', e)
        }
    } else {
        localStorage.setItem(key, data);
    }
}

export function getData(key) {
    let data = null;
    if (key) {
        if (key === ACCESS_TOKEN || key === REFRESH_TOKEN) {
            data = Cookies.get(key);
        } else {
            data = localStorage.getItem(key);
        }
    } else {
        data = Cookies.get(ACCESS_TOKEN);
    }
    return data;
}

export function clearSession(key) {
    if (key)
        localStorage.removeItem(key);
    else {
        try {
            Cookies.remove(ACCESS_TOKEN, connection.cookiesConfig);
            Cookies.remove(REFRESH_TOKEN, connection.cookiesConfig);
            // localStorage.clear();
            localStorage.removeItem("communities");
        }
        catch (e) {
            console.log('clearSession e:', e)
        }
    }

}

export function initLanguage() {
    try {
        let storedLanguage = localStorage.getItem(LANGUAGE);
        if (!storedLanguage) {
            storeLanguageAsync(language_id, null);
        } else {
            language_id = storedLanguage;
            i18n.changeLanguage(language_id);
        }
    } catch (ex) {
        i18n.changeLanguage(language_id);
    }
    return language_id;
}

export function storeLanguageAsync(language) {
    try {
        i18n.changeLanguage(language);
        localStorage.setItem(LANGUAGE, language);
        language_id = language;
    }
    catch (err) {
        console.log("EXCEPTION  storeLanguageAsync ", err);
        throw err;
    }
}

export function getLanguage() {
    return language_id;
}

export function initOptionHeader() {
    return {
        'User-Agent': 'request',
        'Content-Type': 'application/json; charset=utf-8'
    }
}

export async function logOut(isSessionExpire, navigate) {
    if (!is_logout_call || !isSessionExpire) {//bị hết hạn lần đầu hoặc logout chủ động
        clearSession();
        cache.clearStorage();
        navigate(config_path.login)
        is_logout_call = true;
    }
}

export function getLogoImage() {
    var logoUrl = "";
    var app_config = cache.getAppConfig();
    if (app_config && app_config.creatives && app_config.creatives.length > 0) {
        let business_logo = dataUtil.getImageByUsageTypePortal(app_config.creatives, usage_type.APP_LOGO, true);
        if (business_logo) {
            logoUrl = business_logo && business_logo.url ? business_logo.url : null;
        }
    }
    return logoUrl;
}

